/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CustomerScheduleLogsService = {
  async saveCustomerCallLog(payload) {
    var url = "api/Save_CalendarSchedule";

    return await ApiService.post(url, payload, "String");
  },

  async getScheduleLogsByRecordId(RecordId) {
    const requestScreenData = {
      url: "api/CalendarSchedule",
      filter: `RecordId eq ${RecordId}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async saveCustomerCallLogSingleEvent(payload) {
    var url = "api/Save_CallLog/FromCalendarSchedule";

    return await ApiService.post(url, payload, "String");
  },

  async deleteSingleEvent(callLogHeaderRecordId) {
    var url = `api/Save_CalendarSchedule/${callLogHeaderRecordId}/DeleteSingleEvent`;

    return await ApiService.post(url, null, "String");
  },
  async deleteEventSeriesForCallLog(callLogHeaderRecordId) {
    var url = `api/Save_CalendarSchedule/${callLogHeaderRecordId}/DeleteEventSeries`;

    return await ApiService.post(url, null, "String");
  },
};

export { CustomerScheduleLogsService };
